<template>
    <div id="app">
        <!-- >>> Scheduler 1: 'Calendar' ----------------------------------- -->
        <bryntum-scheduler
            ref="scheduler1"
            v-bind="scheduler1Config"
            :key="get_Events + get_Resources + get_flights_Events_Filtered + get_flights_Resources_Filtered"
            :events = "get_Events"
            :resources = "get_Resources"
            :resourceTimeRanges = "get_ResourceTimeRanges"
            :startDate = "start"
            :endDate = "end"
        />
        <!-- <<< Scheduler 1: 'Calendar' ----------------------------------- -->

        <bryntum-splitter />

        <!-- >>> Scheduler 2: 'Flights' ------------------------------------ -->
        <bryntum-scheduler
            v-show="get_shared_SchedulersSynchronizedMode === true"
            ref="scheduler2"
            v-bind="scheduler2Config"
            :events="get_flights_Events_Filtered"
            :resources="get_flights_Resources_Filtered"
            :startDate = "startFlights"
            :endDate = "endFlights"
        />
        <!-- <<< Scheduler 2: 'Flights' ------------------------------------ -->





        <!-- >>> ----------------------------------------------------------- -->
        <event-editor-flight
            v-model="showEditorFlight"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-flight>
        <!-- <<< 'FLIGHT' - update, create --------------------------------- -->

        <!-- >>> 'AVAILABLE' - update, create ------------------------------ -->
        <event-editor-available
            v-model="showEditorAvailable"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-available>
        <!-- <<< 'AVAILABLE' - update, create ------------------------------ -->

        <!-- >>> 'FREEDAY' - update, create -------------------------------- -->
        <event-editor-freeday
            v-model="showEditorFreeday"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-freeday>
        <!-- <<< 'FREEDAY' - update, create -------------------------------- -->

        <!-- >>> 'RES' - update, create ------------------------------------ -->
        <event-editor-reserve
            v-model="showEditorReserve"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-reserve>
        <!-- <<< 'RES' - update, create ------------------------------------ -->

        <!-- >>> 'VACATION' - update, create ------------------------------- -->
        <event-editor-vacation
            v-model="showEditorVacation"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-vacation>
        <!-- >>> 'VACATION' - update, create ------------------------------- -->

        <!-- >>> 'DAYOFF' - Multiple, update, create ----------------------- -->
        <event-editor-dayoff
            v-model="showEditorDayoff"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-dayoff>
        <!-- <<< 'DAYOFF' - Multiple, update, create ----------------------- -->

        <!-- >>> 'HOTEL' - Multiple, update, create ------------------------ -->
        <event-editor-hotel
            v-model="showEditorHotel"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-hotel>
        <!-- <<< 'HOTEL' - Multiple, update, create ------------------------ -->

        <!-- >>> 'MEETING' - Multiple, update, create ---------------------- -->
        <event-editor-meeting
            v-model="showEditorMeeting"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-meeting>
        <!-- <<< 'MEETING' - Multiple, update, create ---------------------- -->

        <!-- >>> 'OFFICE' - Multiple, update, create ----------------------- -->
        <event-editor-office
            v-model="showEditorOffice"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-office>
        <!-- <<< 'OFFICE' - Multiple, update, create ----------------------- -->

        <!-- >>> 'PRO' - Multiple, update, create -------------------------- -->
        <event-editor-proceeding
            v-model="showEditorProceeding"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-proceeding>
        <!-- <<< 'PRO' - Multiple, update, create -------------------------- -->

        <!-- >>> 'STANDBY' - Multiple, update, create ---------------------- -->
        <event-editor-standby
            v-model="showEditorStandby"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-standby>
        <event-editor-standby-activate
            v-model="showEditorStandbyActivate"
            :eventRecord="eventRecord"
            :eventStore="eventStore"
            :resourceId="resourceId"
            @close="onClose_Editors">
        </event-editor-standby-activate>
        <!-- <<< 'STANDBY' - Multiple, update, create ---------------------- -->

        <!-- >>> 'SICKNESS' - Multiple, update, create --------------------- -->
        <event-editor-sickness
            v-model="showEditorSickness"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-sickness>
        <event-editor-sickness-change-status
            v-model="showEditorSicknessChangeStatus"
            :eventRecord="eventRecord"
            :eventStore="eventStore"
            :resourceId="resourceId"
            @close="onClose_Editors">
        </event-editor-sickness-change-status>
        <!-- <<< 'SICKNESS' - Multiple, update, create --------------------- -->

        <!-- >>> 'TRAINING' - Multiple, update, create --------------------- -->
        <event-editor-training
            v-model="showEditorTraining"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-training>
        <!-- <<< 'TRAINING' - Multiple, update, create --------------------- -->

        <!-- >>> 'UNABLEFLIGHT' - Multiple, update, create ----------------- -->
        <event-editor-unableflight
            v-model="showEditorUnableFlight"
            :eventStore="eventStore"
            :resourceId="resourceId"
            :eventRecord="eventRecord"
            :resourceRecord="resourceRecord"
            :addDate="addDate"
            :eventName="eventName"
            :editorMode="editorMode"
            @close="onClose_Editors">
        </event-editor-unableflight>
        <!-- <<< 'UNABLEFLIGHT' - Multiple, update, create ----------------- -->
        <!-- <<< ----------------------------------------------------------- -->




        <!-- >>> 'UPDATECREWONFLIGHT' - Multiple, update, create ----------- -->
		<sdr-member-on-crew-bottom-sheet
            v-model="showSheet_MemberOnCrew"
            :get_areThereTrtainingsFlights="get_areThereTrtainingsFlights">
		</sdr-member-on-crew-bottom-sheet>
        <!-- <<< 'UPDATECREWONFLIGHT' - Multiple, update, create ----------- -->




        <!-- >>> 'Want to delete all marked ones?' - Dialog ---------------- -->
        <v-dialog v-model="dialogDeleteMulti" max-width="470">
            <v-card>
                <v-card-title class="grey lighten pa-5" style="color: white; font-size: 1.3rem; font-weight: 500;"><i style="color: #e53f2c;" class="b-fa b-fa-exclamation-triangle"></i>&nbsp;&nbsp;Delete all marked Events</v-card-title>

                <v-card-text class="pa-5" style="font-size: 1.2rem; font-weight: 400;">
                    You want to continue and delete all?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="dialogDeleteMulti = false; agreeDeleteMulti = false;">Disagree</v-btn>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="dialogDeleteMulti = false; agreeDeleteMulti = true;">Agree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- <<< 'Want to delete all marked ones?' - Dialog ---------------- -->


        <!-- >>> 'Want to delete single duty?' - Dialog -------------------- -->
        <v-dialog v-model="dialogDeleteSingle" max-width="470">
            <v-card>
                <v-card-title class="grey lighten pa-5" style="color: white; font-size: 1.3rem; font-weight: 500;"><i style="color: #e53f2c;" class="b-fa b-fa-exclamation-triangle"></i>&nbsp;&nbsp;Delete this single Event</v-card-title>

                <v-card-text class="pa-5" style="font-size: 1.2rem; font-weight: 400;">
                    You want to continue and delete this single Event?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="dialogDeleteSingle = false; agreeDeleteSingle = false;">Disagree</v-btn>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="dialogDeleteSingle = false; agreeDeleteSingle = true;">Agree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--<<< 'Want to delete single duty?' - Dialog --------------------- -->


        <!-- >>> Dialog: 'Shared - Warning' -------------------------------- -->
        <v-dialog
            v-if="get_shared_Warning"
            v-model="warningDialog"
            max-width="744px">
            <v-card style="text-align:center;">
                <v-card-title>
                    <v-card-title class="mb-0 mt-5 font-weight-bold" style="font-size:1.8rem;">{{  get_shared_Warning.title  }}</v-card-title>
                </v-card-title>
                <v-card-text class="pa-8 pt-0 pb-0">
                    <div v-html="get_shared_Warning.text"></div>
                </v-card-text>
                <v-card-actions class="pt-8">
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px" depressed outlined color="#ab3b7a" @click="get_shared_Warning.declineFunction(), actn_set_Warning(null)">Decline</v-btn>
                    <v-btn style="width:120px" depressed color="primary" @click="get_shared_Warning.acceptFunction(), actn_set_Warning(null)">Accept</v-btn>
				</v-card-actions>
            </v-card>
        </v-dialog>
        <!-- <<< Dialog: 'Shared - Warning' -------------------------------- -->


        <!-- >>> 'Attention TrainigsFlight!' - Dialog ---------------------- -->
        <v-dialog v-model="dialogSwitchDutyTrainingFlight" max-width="470">
            <v-card>
                <v-card-title class="grey lighten pa-5" style="color: white; font-size: 1.3rem; font-weight: 500;"><i style="color: #e53f2c;" class="b-fa b-fa-exclamation-triangle"></i>&nbsp;&nbsp;There is a Training-Flight in your Swich Duty!</v-card-title>

                <v-card-text class="pa-5" style="font-size: 1.2rem; font-weight: 400;">
                    You want to continue with this Switch Duty?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="dialogSwitchDutyTrainingFlight = false;">Disagree</v-btn>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onClick_SwitchDuty_Agree">Agree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- <<< 'Attention TrainigsFlight!' - Dialog ---------------------- -->




        <!-- >>> Sdr-Component, BottomSheet -------------------------------- -->
		<sdr-crewdetails-bottom-sheet
			v-model="showSheetCrewDetails"
            editorMode="create"
            :eventRecord="eventRecord">
		</sdr-crewdetails-bottom-sheet>
        <!-- >>> Sdr-Component, BottomSheet -------------------------------- -->

        <!-- >>> Floating 'Add' Button ------------------------------------- -->
        <!-- <v-fab-transition>
            <v-btn
                fab
                fixed
                color="primary"
                bottom
                right
                style="margin-bottom: 50px; margin-right: 50px;"
                @click="onClick_FloatingButton()"
                :disabled="get_Events.length <= 0">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-fab-transition> -->
        <!-- <<< Floating 'Add' Button ------------------------------------- -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        CONF_CALENDAR_DAYS_RANGE,
    } from '../../../config.js'

    import { BryntumScheduler, BryntumSplitter } from '@bryntum/scheduler-vue';
    import { scheduler1Config, scheduler2Config } from './components/AppConfig'; // 'Calendar', 'Flights'

    import Mixin_Home_Editors from './mixins/Mixin_Home_Editors.vue'; // MixIn: 'Editors'
    import Mixin_Home_DragAndDrop from './mixins/Mixin_Home_DragAndDrop.vue'; // MixIn: 'Drag&Drop'

    import EventEditorFlight from './components/calendar/editevents/flight/EventEditor.vue'; // event editor FLIGHT (comment)
    import EventEditorAvailable from './components/calendar/editevents/available/EventEditor.vue'; // event editor AVAILABLE ('update', 'create')
    import EventEditorFreeday from './components/calendar/editevents/freeday/EventEditor.vue'; // event editor FREEDAY ('update', 'create')
    import EventEditorReserve from './components/calendar/editevents/reserve/EventEditor.vue'; // event editor RESERVE ('update', 'create')
    import EventEditorSickness from './components/calendar/editevents/sickness/EventEditor.vue'; // event editor SICKNESS ('update', 'create')
    import EventEditorVacation from './components/calendar/editevents/vacation/EventEditor.vue'; // event editor VACATION ('update', 'create')
    import EventEditorDayoff from './components/calendar/editevents/dayoff/EventEditor.vue'; // event editor DAYOFF (multiple 'update', 'create')
    import EventEditorHotel from './components/calendar/editevents/hotel/EventEditor.vue'; // event editor HOTEL (multiple 'update', 'create')
    import EventEditorMeeting from './components/calendar/editevents/meeting/EventEditor.vue'; // event editor MEETING (multiple 'update', 'create')
    import EventEditorOffice from './components/calendar/editevents/office/EventEditor.vue'; // event editor OFFICE (multiple 'update', 'create')
    import EventEditorProceeding from './components/calendar/editevents/proceeding/EventEditor.vue'; // event editor PROCEEDING (multiple 'update', 'create')
    import EventEditorStandby from './components/calendar/editevents/standby/EventEditor.vue'; // event editor STANDBY (multiple 'update', 'create')
    import EventEditorTraining from './components/calendar/editevents/training/EventEditor.vue'; // event editor TRAINING (multiple 'update', 'create')
    import EventEditorUnableflight from './components/calendar/editevents/unableflight/EventEditor.vue'; // event editor UNABLEFLIGHT (multiple 'update', 'create')

    import EventEditorSicknessChangeStatus from './components/calendar/editevents/sickness/EventEditorChangeStatus.vue'; // event editor SICKNESS ('change multiple status')
    import EventEditorStandbyActivate from './components/calendar/editevents/standby/EventEditorActivate.vue'; // event editor STANDBY (activate)

	import MemberOnCrewBottomSheet from './components/calendar/crewupdate/BottomSheetMemberOnCrew.vue';
    import CrewDetailsBottomSheet from './components/calendar/crewdetails/BottomSheetCreate.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../main';
    import moment from 'moment';


    export default {
        name: 'CrewplanningHome',
        mixins: [
            Mixin_Home_DragAndDrop,
            Mixin_Home_Editors
        ],

        /* >>> *************************************************************** / /* Components */
        components: {

            BryntumScheduler,
            BryntumSplitter,

            EventEditorFlight,
            EventEditorAvailable,
            EventEditorFreeday,
            EventEditorReserve,
            EventEditorSickness,
            EventEditorVacation,

            EventEditorDayoff,
            EventEditorHotel,
            EventEditorMeeting,
            EventEditorOffice,
            EventEditorProceeding,
            EventEditorStandby,
            EventEditorTraining,
            EventEditorUnableflight,

            EventEditorSicknessChangeStatus,
            EventEditorStandbyActivate,

            'sdr-member-on-crew-bottom-sheet': MemberOnCrewBottomSheet,
            'sdr-crewdetails-bottom-sheet': CrewDetailsBottomSheet,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------
                scheduler1Config,
                scheduler2Config,
                // >>> ------------------------------------
                start: null, // 'Calendar', Start, End
                end: null,
                startFlights: null, // 'Flights', Start, End
                endFlights: null,
                // >>> ------------------------------------
                showEditorFlight: false,
                showEditorAvailable: false, // Event-Editors shown, single
                showEditorFreeday: false,
                showEditorReserve: false,
                showEditorSickness: false,
                showEditorVacation: false,
                showEditorDayoff: false, // Event-Editors shown, multiple
                showEditorHotel: false,
                showEditorMeeting: false,
                showEditorOffice: false,
                showEditorProceeding: false,
                showEditorStandby: false,
                showEditorTraining: false,
                showEditorUnableFlight: false,
                showEditorSicknessChangeStatus: false, // Event-Editors shown, change status
                showEditorStandbyActivate: false,
                // >>> ------------------------------------
                eventStore: null, // Event-Editor-UPDATE
                resourceId: null,
                eventRecord: null,
                // >>> ------------------------------------
                resourceRecord: null, // Event-Editor-CREATE
                addDate: null,
                // >>> ------------------------------------
                eventName: null, // Event-Editor-BOTH
                editorMode: null,
                // >>> ------------------------------------
                dialogDeleteMulti: false, // Dialog: 'Wann delete all marked?'
                agreeDeleteMulti: false, // Dialog: 'Wann delete all marked?'
                dialogDeleteSingle: false, // Dialog: 'Wann delete single one?'
                agreeDeleteSingle: false, // Dialog: 'Wann delete single one?'
                tmpDeleteSingleRecord: null , // save Record to delete temporarily
                // >>> ------------------------------------
                dialogSwitchDutyTrainingFlight: false, // Dialog: 'Wann switch duty to training flight?'
                backupTheData: null, // save data temporarily
                // >>> ------------------------------------
                key: 0,
				// >>> ------------------------------------ 'Member on Crew Bottom Sheet'
				showSheet_MemberOnCrew: false,
                // >>> ------------------------------------ 'Crew Details Bottom Sheet'
                showSheetCrewDetails: false,
                editorMode: null, // 'update, create'
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            agreeDeleteMulti(value) {

                if (value === true) {
                    this.onClick_Delete_AllMarkedDuties();
                }

            }, // eo function agreeDeleteMulti()


            agreeDeleteSingle(value) {

                if (value === true) {
                    this.onClick_Delete_SingleDuty();
                }

            }, // eo function agreeDeleteMulti()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_shared_Warning',
                // >>> ------------------------------------
                'get_Resources',
                'get_Events',
                'get_ResourceTimeRanges',
                // >>> ------------------------------------
                'get_flights_Resources_Filtered',
                'get_flights_Events_Filtered',
                // >>> ------------------------------------
                'get_selectedMultiEvents', // get: selected Events
                'get_selectedMultiEventsEntireRecord', // get: selected Events (entire records)
                'get_selectedMultiResources',
                // >>> ------------------------------------
                'get_shared_SchedulersSynchronizedMode',
                // >>> ------------------------------------
                'get_shared_IsSchedulerReadOnly',
                'get_shared_IsDutyAccessAllowed',
                // >>> ------------------------------------
                'get_crews_Complete_Names',
                // >>> ------------------------------------
                'get_shared_IsEditingInThePastAllowed',
                // >>> ------------------------------------
                'get_areThereTrainingsFlightsOnDateAndResources',
            ]),


            /*******************************************************************
            * warningDialog()
            *
            * Desc:
            * Note:
            *
            */
            warningDialog: {

                get () {

                    const me = this;


                    if (me.get_shared_Warning !== null) {
                        return true;
                    } else {
                        return false;
                    }

                }, // eo function get warningDialog()

                set (value) {

                    const me = this;


                    if (value === false) {
                        me.get_shared_Warning.declineFunction();
                        me.actn_set_Warning(null);
                    }

                } // eo function set warningDialog()

            } // eo function warningDialog()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        * Note: Set Start Dates/Times in both Schedulers.
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> created');
            // >>> ---------------------------------------- set 'calendar' width
            this.start = new Date();
            this.start.setHours(0);
            this.start.setMinutes(0);
            this.start.setSeconds(0);

            this.end = moment().add(+CONF_CALENDAR_DAYS_RANGE, 'd').toDate();
            this.end.setHours(23);
            this.end.setMinutes(59);
            this.end.setSeconds(59);

            // >>> ---------------------------------------- set 'flights' width
            this.startFlights = new Date();
            this.startFlights.setHours(0);
            this.startFlights.setMinutes(0);
            this.startFlights.setSeconds(0);

            this.endFlights = moment().add(+CONF_CALENDAR_DAYS_RANGE, 'd').toDate();
            this.endFlights.setHours(23);
            this.endFlights.setMinutes(59);
            this.endFlights.setSeconds(59);


            // eventBus.$on('datachange', this.onSyncData); // Just for Fun right now
            // >>> ---------------------------------------- 'Calendar Config Listener'
            eventBus.$on('eventSelectionChange_Calendar', this.eventSelectionChange_Calendar_Handler);
            eventBus.$on('selectionChange_Calendar', this.resourceSelectionChange_Calendar_Handler);

            eventBus.$on('beforeEventEdit_Calendar', this.beforeEventEdit_Calendar_Handler);

            // >>> ---------------------------------------- 'Calendar'
            eventBus.$on('datechanged', this.onChange_Scheduler_Date); // searchdates changed listener (used to set dates in scheduler)
            eventBus.$on('filter', this.onChange_Scheduler_Filter); // filter change event listener
            eventBus.$on('tooltip', this.onChange_Scheduler_Tooltip); // appbar, tooltip switch
            eventBus.$on('calibratezoomlevel', this.onChange_Scheduler_ZoomLevel);
            eventBus.$on('resetcalendar', this.onChange_Scheduler_ResetCalendar);

            eventBus.$on('deselectall', this.onScheduler_DeselectAll); // deselectall
            eventBus.$on('deselectallflights', this.onScheduler_DeselectAllFlights); // deselectall

            eventBus.$on('onclickswitchduty', this.onClick_SwitchDuty); // switch: Duty
            eventBus.$on('updatedswitchduty', this.onUpdate_SwitchDuty);

            // >>> ---------------------------------------- 'add single'
            eventBus.$on('onclickphonenumber', this.onClick_Copy_PhoneNumber); // copy: phone number
            eventBus.$on('onclickaddavailable', this.onClick_Add_Available); // add: 'AVAILABLE'
            eventBus.$on('onclickaddfreeday', this.onClick_Add_Freeday); // add: 'FREEDAY'
            eventBus.$on('onclickaddreserve', this.onClick_Add_Reserve); // add: 'RESERVE'
            // eventBus.$on('onclickaddsickness', this.onClick_Add_Sickness); // add: 'SICKNESS'
            eventBus.$on('onclickaddvacation', this.onClick_Add_Vacation); // add: 'VACATION'
            // >>> ---------------------------------------- 'add multiple'
            eventBus.$on('onclickaddmultipledayoff', this.onClick_Add_Multiple_Dayoffs); // add: 'DAYOFF'
            eventBus.$on('onclickaddmultiplehotels', this.onClick_Add_Multiple_Hotels); // add: 'HOTEL'
            eventBus.$on('onclickaddmultiplemeetings', this.onAdd_Multiple_Meetings); // add: 'MEETING'
            eventBus.$on('onclickaddmultipleoffice', this.onAdd_Multiple_Office); // add: 'OFFICE'
            eventBus.$on('onclickaddmultipleproceedings', this.onAdd_Multiple_Proceedings); // add: 'PROCEEDING'
            eventBus.$on('onclickaddmultiplestandby', this.onAdd_Multiple_Standby); // add: 'STANDBY'
            eventBus.$on('onclickaddmultiplesickness', this.onAdd_Multiple_Sickness); // add: 'SICKNESS'
            eventBus.$on('onclickaddmultipletrainings', this.onAdd_Multiple_Trainings); // add : 'TRAINING'
            eventBus.$on('onclickaddmultipleunableflights', this.onAdd_Multiple_UnableFlights); // add: 'UNABLEFLIGHT'

            // >>> ---------------------------------------- 'refresh in scheduler'
            eventBus.$on('createdduty', this.onCreated_Single_Duty); // created: 'single'
            eventBus.$on('createdmultipleduties', this.onCreated_Multiple_Duties); // created: 'multiple'
            eventBus.$on('updatedmultipleduties', this.onUpdated_Multiple_Duties); // updated: 'multiple'

            eventBus.$on('createdmultiplehotels', this.onCreated_Multiple_Hotels); // created: multiple 'HOTEL'
            eventBus.$on('updatedmultiplehotels', this.onUpdate_Multiple_Hotels); // updated: multiple 'HOTEL'
            eventBus.$on('createdmultipleproceedings', this.onCreated_Multiple_Proceedings); // created  : 'PROCEEDING'
            eventBus.$on('updatedmultipleproceedings', this.onUpdate_Multiple_Proceedings); // updated  : 'PROCEEDING'
            eventBus.$on('createdmultipletrainings', this.onCreated_Multiple_Trainings); // created : 'TRAINING'
            eventBus.$on('updatedmultipletrainings', this.onUpdate_Multiple_Trainings); // updated : 'TRAINING'

            // >>> ----------------------------------------
            eventBus.$on('onclickchangestatusmultiplesicknesses', this.onClick_ChangeStatus_MultipleSicknesses); // change status: 'SICKNESS'
            eventBus.$on('changedstatusmultiplesicknesses', this.onChangedStatus_MultipleSicknesses_Finally);

            eventBus.$on('onclickhotelchangestatus', this.onClick_ChangeStatus_SingleHotel); // change status: 'HOTEL'
            eventBus.$on('onclickchangestatusmultiplehotels', this.onClick_ChangeStatus_MultipleHotels);
            eventBus.$on('changedmultiplehotelstatus', this.onClick_ChangeStatus_MultipleHotels_Finally);

            eventBus.$on('onclickproceedingchangestatus', this.onClick_ChangeStatus_SingleProceeding); // change status: 'PROCEEDING'
            eventBus.$on('onclickdayoffchangeactivated', this.onClick_ChangeActivated_SingleDayoff);  // change status/activated: 'DAYOFF'
            eventBus.$on('onclickfreedaychangeactivated', this.onClick_ChangeActivated_SingleFreeday);  // change status/activated: 'FREEEDAY'
            eventBus.$on('onclickstandbychangeactivated', this.onClick_Standby_Activate); // change status/activated: 'STANDBY'

            // >>> ----------------------------------------
            eventBus.$on('onclickdeletesingleduty', this.onClick_Delete_SingleDuty);    // delete: single duty
            eventBus.$on('deletedsingleduty', this.onClick_Delete_SingleDuty_Finally);  // delete: single duty finally
            eventBus.$on('onclickdeleteallmarkedduties', this.onClick_Delete_AllMarkedDuties); // delete: multiple duties
            eventBus.$on('deletedallmarkedduties', this.onClick_Delete_AllMarkedDuties_Finally); // delete: multiple duties finally

            eventBus.$on('updatedmultipleflightcomments', this.onUpdate_Multiple_FlightComments);   // call: modify single duty successful

            eventBus.$on('setemployeesonflights', this.onClick_EmployeeesOnFlight);

            // >>> ---------------------------------------- 'Across Both'
            eventBus.$on('switchschedulerpartneringmode', this.onChange_SchedulerPartneringMode);

            eventBus.$on('onclickshowcompletenames', this.onClick_ShowCompleteNames);

            // this.actn_call_crews_getResourcesOfDepartment({ department: '11', secondLoad: false });
            // this.actn_call_crews_getResourcesOfDepartment({ department: '12', secondLoad: true });

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> destroyed');
            // eventBus.$off('datachange', this.onSyncData); // Just for Fun right now

            // >>> ---------------------------------------- 'Calendar Config Listener'
            eventBus.$off('eventSelectionChange_Calendar', this.eventSelectionChange_Calendar_Handler);
            eventBus.$off('selectionChange_Calendar', this.resourceSelectionChange_Calendar_Handler);

            eventBus.$off('beforeEventEdit_Calendar', this.beforeEventEdit_Calendar_Handler);

            // >>> ---------------------------------------- 'Calendar'
            eventBus.$off('datechanged', this.onChange_Scheduler_Date);
            eventBus.$off('filter', this.onChange_Scheduler_Filter);
            eventBus.$off('tooltip', this.onChange_Scheduler_Tooltip);
            eventBus.$off('calibratezoomlevel', this.onChange_Scheduler_ZoomLevel);
            eventBus.$off('resetcalendar', this.onChange_Scheduler_ResetCalendar);

            eventBus.$off('deselectall', this.onScheduler_DeselectAll);
            eventBus.$off('deselectallflights', this.onScheduler_DeselectAllFlights); // deselectall

            eventBus.$off('onclickswitchduty', this.onClick_SwitchDuty);
            eventBus.$off('updatedswitchduty', this.onUpdate_SwitchDuty);

            // >>> ----------------------------------------
            eventBus.$off('onclickphonenumber', this.onClick_Copy_PhoneNumber);
            eventBus.$off('onclickaddavailable', this.onClick_Add_Available);
            eventBus.$off('onclickaddfreeday', this.onClick_Add_Freeday);
            eventBus.$off('onclickaddreserve', this.onClick_Add_Reserve);
            // eventBus.$off('onclickaddsickness', this.onClick_Add_Sickness);
            eventBus.$off('onclickaddvacation', this.onClick_Add_Vacation);
            // >>> ----------------------------------------
            eventBus.$off('onclickaddmultipledayoff', this.onClick_Add_Multiple_Dayoffs);
            eventBus.$off('onclickaddmultiplehotels', this.onClick_Add_Multiple_Hotels);
            eventBus.$off('onclickaddmultiplemeetings', this.onAdd_Multiple_Meetings);
            eventBus.$off('onclickaddmultipleoffice', this.onAdd_Multiple_Office);
            eventBus.$off('onclickaddmultipleproceedings', this.onAdd_Multiple_Proceedings);
            eventBus.$off('onclickaddmultiplestandby', this.onAdd_Multiple_Standby);
            eventBus.$off('onclickaddmultiplesickness', this.onAdd_Multiple_Sickness);
            eventBus.$off('onclickaddmultipletrainings', this.onAdd_Multiple_Trainings);
            eventBus.$off('onclickaddmultipleunableflights', this.onAdd_Multiple_UnableFlights);

            // >>> ----------------------------------------
            eventBus.$off('createdduty', this.onCreated_Single_Duty);
            eventBus.$off('createdmultipleduties', this.onCreated_Multiple_Duties);
            eventBus.$off('updatedmultipleduties', this.onUpdated_Multiple_Duties);

            eventBus.$off('createdmultiplehotels', this.onCreated_Multiple_Hotels);
            eventBus.$off('updatedmultiplehotels', this.onUpdate_Multiple_Hotels)
            eventBus.$off('createdmultipleproceedings', this.onCreated_Multiple_Proceedings);
            eventBus.$off('updatedmultipleproceedings', this.onUpdate_Multiple_Proceedings);
            eventBus.$off('createdmultipletrainings', this.onCreated_Multiple_Trainings);
            eventBus.$off('updatedmultipletrainings', this.onUpdate_Multiple_Trainings);

            // >>> ----------------------------------------
            eventBus.$off('onclickchangestatusmultiplesicknesses', this.onClick_ChangeStatus_MultipleSicknesses);
            eventBus.$off('changedstatusmultiplesicknesses', this.onChangedStatus_MultipleSicknesses_Finally);

            eventBus.$off('onclickhotelchangestatus', this.onClick_ChangeStatus_SingleHotel);
            eventBus.$off('onclickchangestatusmultiplehotels', this.onClick_ChangeStatus_MultipleHotels);
            eventBus.$off('changedmultiplehotelstatus', this.onClick_ChangeStatus_MultipleHotels_Finally);

            eventBus.$off('onclickproceedingchangestatus', this.onClick_ChangeStatus_SingleProceeding);
            eventBus.$off('onclickdayoffchangeactivated', this.onClick_ChangeActivated_SingleDayoff);
            eventBus.$off('onclickfreedaychangeactivated', this.onClick_ChangeActivated_SingleFreeday);
            eventBus.$off('onclickactivatestandby', this.onClick_Standby_Activate);

            // >>> ----------------------------------------
            eventBus.$off('onclickdeletesingleduty', this.onClick_Delete_SingleDuty);
            eventBus.$off('deletedsingleduty', this.onClick_Delete_SingleDuty_Finally);
            eventBus.$off('onclickdeleteallmarkedduties', this.onClick_Delete_AllMarkedDuties);
            eventBus.$off('deletedallmarkedduties', this.onClick_Delete_AllMarkedDuties_Finally);

            eventBus.$on('updatedmultipleflightcomments', this.onUpdate_Multiple_FlightComments);

            eventBus.$off('setemployeesonflights', this.onClick_EmployeeesOnFlight);

            // >>> ---------------------------------------- 'Across Both'
            eventBus.$off('switchschedulerpartneringmode', me.onChange_SchedulerPartneringMode);

            eventBus.$off('onclickshowcompletenames', this.onClick_ShowCompleteNames);

		}, // eo function destroyed()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Connect/Partner the 2 Scheduler.
        * Note: Make schedulers partnered so that they scroll together.
        * Note: Check here for Users Readonly/Admin Grants.
        *
        */
        mounted: function() {

            let me = this,
                scheduler1 = me.$refs.scheduler1.instance,
                scheduler2 = '';


            me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> mounted');
            // >>> ---------------------------------------- 'Partnering'
            if (this.get_shared_SchedulersSynchronizedMode === true) {
                scheduler2 = me.$refs.scheduler2.instance;
                this.$refs.scheduler2.instance.addPartner(this.$refs.scheduler1.instance); // partner @startup
            }


            // >>> ---------------------------------------- 'Reset'
            this.actn_load_Hotels({});
            this.actn_load_Trainings({});
            this.actn_load_AllEmployees({});


            // >>> ---------------------------------------- Grants 'Calendar'
            if (this.get_shared_IsSchedulerReadOnly({ scheduler: 'CALENDAR' })) { // read-only?
                scheduler1.readOnly = true;
                scheduler1.features.eventMenu.disabled = true;
                scheduler1.features.scheduleMenu.disabled = true;

                Vue.prototype.$toasted.global.sdr_app_info({
                    message: 'Attention: Dear User, CALENDAR is in Mode - read-only.'
                });
            }


            // >>> ---------------------------------------- Grants 'Flights'
            if (this.get_shared_SchedulersSynchronizedMode === true) {

                if (this.get_shared_IsSchedulerReadOnly({ scheduler: 'FLIGHTS' })) { // read-only?
                    scheduler2.readOnly = true;
                    scheduler2.features.eventMenu.disabled = true;
                    scheduler2.features.scheduleMenu.disabled = true;

                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, FLIGHTS is in Mode - read-only.'
                    });
                }

            }


            // scheduler2.features.eventDrag.unifiedDrag = true; // ???


        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc:
        * Note:
        *
        */
        updated: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> updated');
            if (this.get_shared_SchedulersSynchronizedMode === true) {
                me.$refs.scheduler2.instance.addPartner(me.$refs.scheduler1.instance); // partner @startup
            }

        }, // eo function updated()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_Warning',
                // >>> ------------------------------------
                'actn_switch_Duty', // Call: Switch Duty
                'actn_load_Hotels', // Call: Load 'Hotels' at created
                'actn_load_Trainings', // Call: Load 'Trainings' at created
                'actn_load_AllEmployees', // Call: Load 'All Employees' at created
                // >>> ------------------------------------
                'actn_set_SelectedMultiEvents',
                'actn_set_SelectedMultiResources',
                // >>> ------------------------------------
                'actn_delete_SingleDuty',
                'actn_delete_AllMarkedDuties',
                // >>> ------------------------------------
                'actn_set_HotelStatus', // Call: Set Hotels Status
                'actn_set_HotelStatusMultiple', // Call: Set Hotels Status (multiple)
                // >>> ------------------------------------
                'actn_set_ProceedingStatus', // Call: Set Proceeding Status
                'actn_set_DayoffActivated', // Call: Set Dayoff Activated
                'actn_set_FreedayActivated', // Call: Set Freeday Activated
                // >>> ------------------------------------
                'actn_call_crews_getResourcesOfDepartment',
            ]),


            /******************************************************************* 'Listeners - Scheduler 'Calendar''
            * Listeners: Scheduler 'Calendar'
            *******************************************************************/
            /******************************************************************* 'Date changed'
            * onDateChange()
            *
            * Desc:
            * Note:
            * Note: Set Start Dates/Times in both Schedulers.
            * Note: New Date Set for 'Flights' is not needed bec if Partnering Mode.
            *
            * @param {Object} value ()
            */
            onChange_Scheduler_Date: function(value) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onChange_Scheduler_Date');
                // console.log(JSON.stringify(value))
                // console.log('value.from: ' + value.from)
                // console.log('value.to: ' + value.to)

                // console.log(moment(value.from).toDate())
                // console.log(moment(value.to).subtract(1, 'd').toDate())


                // >>> set @first ------------------------- 'Calendar'
                this.start = moment(value.from).toDate();
                this.start.setHours(0);
                this.start.setMinutes(0);
                this.start.setSeconds(0);

                // >>> set @second ------------------------ 'Calendar'
                // setTimeout(() => {
                    this.end = moment(value.to).subtract(1, 'd').toDate();
                    this.end.setHours(23);
                    this.end.setMinutes(59);
                    this.end.setSeconds(59);
                // }, 750);

                // console.log('--------------')
                // console.log(this.start)
                // console.log(this.end)

            }, // eo function onChange_Scheduler_Date()


            /******************************************************************* 'Filter Events'
            * onChange_Scheduler_Filter()
            *
            * Desc: Handle Duty Filter in Scheduler.
            * Note:
            *
            * @param {String} value (Duty to filter fors)
            */
            onChange_Scheduler_Filter: function(value) {

                let me = this,
                    scheduler = this.$refs.scheduler1.instance; // this.$refs.scheduler.schedulerEngine;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onChange_Scheduler_Filter');
                value = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

                // Replace all previous filters and set a new filter
                scheduler.eventStore.filter({
                    filters : event => event.name.match(new RegExp(value, 'i')),
                    replace : true
                });

            }, // eo function onChange_Scheduler_Filter()


            /******************************************************************* 'Tooltip on/off'
            * onTooltipChange()
            *
            * Desc: Handle Tooltip On/Off.
            * Note:
            *
            * @param {Boolean} value (true,false)
            */
            onChange_Scheduler_Tooltip: function(value) {

                let me = this,
                    scheduler1 = this.$refs.scheduler1.instance,
                    scheduler2 = '';


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onChange_Scheduler_Tooltip');
                scheduler1.features.eventTooltip.tooltip.disabled = !value; // disabled: therefore opposite
                if (this.get_shared_SchedulersSynchronizedMode === true) {
                    scheduler2 = this.$refs.scheduler2.instance;
                    scheduler2.features.eventTooltip.tooltip.disabled = !value; // disabled: therefore opposite
                }

            }, // eo function onChange_Scheduler_Tooltip()


            /******************************************************************* 'Zoom'
            * onChange_Scheduler_ZoomLevel()
            *
            * Desc: Zoom was changed.
            * Note: Sets Zoom Level of the Calendar.
            *
            */
            onChange_Scheduler_ZoomLevel: function(value) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onChange_Scheduler_ZoomLevel');
                setTimeout(() => {
                    me.$refs.scheduler1.instance.viewPreset = value;
                }, 250);

            }, // eo function onChange_Scheduler_ZoomLevel()


            /******************************************************************* 'Reset Calendar'
            * onChange_Scheduler_ResetCalendar()
            *
            * Desc: Resest Calendar.
            * Note:
            *
            */
            onChange_Scheduler_ResetCalendar: function(value) {

                let me = this,
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onChange_Scheduler_ResetCalendar');
                schedulerCalendar.resourceStore.clearFilters();

            }, // eo function onChange_Scheduler_ResetCalendar()


            /******************************************************************* 'Copy PhoneNo'
            * onClick_Copy_PhoneNumber()
            *
            * Desc: Copy 'Phone No' ,
            * Note:
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_Copy_PhoneNumber: function(str) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Copy_PhoneNumber');
                const el = document.createElement('textarea');
                el.value = str;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);

            }, // eo function onClick_Copy_PhoneNumber()




            /******************************************************************* 'Listeners - Scheduler 'Calendar' - Before Event Edit'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * beforeEventEdit_Calendar_Handler()
            *
            * Desc: Before Event - Edit Handler 'Calendar'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} event ()
            */
            beforeEventEdit_Calendar_Handler: function(event) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> beforeEventEdit_Calendar_Handler');
                // >>> -------------------------------------------------------- // >>> SINGLE EDIT
                if (event.eventRecord.name === 'FLIGHT') {                      // 'update' => 'Flight Comment', 'check calendar grant'
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'FLIGHT',
                        editorMode          : 'update',
                        showEditorFlight    : true,
                    });
                }

                if (event.eventRecord.name === 'FREEDAY') {                     // 'update', 'create', 'check calendar grant (beforeEventEdit->AppConfig)', 'admin past check here'
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'FREEDAY',
                        editorMode          : 'update',
                        showEditorFreeday   : true,
                    });
                }

                if (event.eventRecord.name === 'VACATION') {                    // 'update', 'create', 'check calendar grant'
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'VACATION',
                        editorMode          : 'update',
                        showEditorVacation : true,
                    });
                }

                if (event.eventRecord.name === 'AVAILABLE') {                   // 'update', 'create', 'check calendar grant'
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'AVAILABLE',
                        editorMode          : 'update',
                        showEditorAvailable : true,
                    });
                }

                if (event.eventRecord.name === 'RESERVE') {                     // 'update', 'create', 'check calendar grant'
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'RESERVE',
                        editorMode          : 'update',
                        showEditorReserve   : true
                    });
                }
                // <<< ---------------------------------------------------------


                // >>> ---------------------------------------------------------// >>> MULTIPLE EDIT
                if (event.eventRecord.name === 'HOTEL') {                       // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('HOTEL').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'HOTEL',
                        editorMode          : 'update',
                        showEditorHotel    : true
                    });
                }

                if (event.eventRecord.name === 'PROCEEDING') {                  // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('PROCEEDING').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore              : event.source.eventStore,      // update
                        resourceId              : event.resourceRecord.id,      // update
                        eventRecord             : event.eventRecord,            // update
                        resourceRecord          : null,                         // create
                        addDate                 : null,                         // create
                        eventName               : 'PROCEEDING',
                        editorMode              : 'update',
                        showEditorProceeding    : true
                    });
                }

                if (event.eventRecord.name === 'TRAINING') {                    // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('TRAINING').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore              : event.source.eventStore,      // update
                        resourceId              : event.resourceRecord.id,      // update
                        eventRecord             : event.eventRecord,            // update
                        resourceRecord          : null,                         // create
                        addDate                 : null,                         // create
                        eventName               : 'TRAINING',
                        editorMode              : 'update',
                        showEditorTraining      : true
                    });
                }

                if (event.eventRecord.name === 'MEETING') {                     // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('MEETING').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'MEETING',
                        editorMode          : 'update',
                        showEditorMeeting   : true
                    });
                }

                if (event.eventRecord.name === 'STANDBY') {                     // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('STANDBY').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'STANDBY',
                        editorMode          : 'update',
                        showEditorStandby   : true
                    });
                }

                if (event.eventRecord.name === 'SICKNESS') {                    // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('SICKNESS').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'SICKNESS',
                        editorMode          : 'update',
                        showEditorSickness : true,
                    });
                }

                if (event.eventRecord.name === 'UNABLEFLIGHT') {                // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('UNABLEFLIGHT').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'UNABLEFLIGHT',
                        editorMode          : 'update',
                        showEditorUnableFlight : true,
                    });
                }

                if (event.eventRecord.name === 'OFFICE') {                      // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('OFFICE').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord));   // Save in State
                    }
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'OFFICE',
                        editorMode          : 'update',
                        showEditorOffice    : true
                    });
                }

                if (event.eventRecord.name === 'DAYOFF') {                      // 'update', 'create', 'check calendar grant'
                    if (this.get_selectedMultiEvents('DAYOFF').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(event.eventRecord)); // Save in State
                    }
                    Object.assign(this, {
                        eventStore          : event.source.eventStore,          // update
                        resourceId          : event.resourceRecord.id,          // update
                        eventRecord         : event.eventRecord,                // update
                        resourceRecord      : null,                             // create
                        addDate             : null,                             // create
                        eventName           : 'DAYOFF',
                        editorMode          : 'update',
                        showEditorDayoff    : true
                        });
                }
                // <<< ---------------------------------------------------------

            }, // eo function beforeEventEdit_Calendar_Handler()




            /******************************************************************* 'Listeners - Multi Event/Resource Selection'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Multi Event Select'
            * eventSelectionChange_Calendar_Handler()
            *
            * Desc: Fires on Event Selection (Change) - Handler.
            * Note: Set Selection into State.
            *
            * @param {Object} selection (Object of Selections)
            */
            eventSelectionChange_Calendar_Handler: function({ selection }) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> eventSelectionChange_Calendar_Handler');
                this.actn_set_SelectedMultiEvents(selection); // Save in State

            }, // eo function eventSelectionChange_Calendar_Handler()


            /******************************************************************* 'Multi Row/Cell Select'
            * resourceSelectionChange_Calendar_Handler()
            *
            * Desc: Fires on Row/Cell Selection (Change) - Handler.
            * Note:
            *
            * @param {Object} selection (Object of Selections)
            */
            resourceSelectionChange_Calendar_Handler: function(selection) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> resourceSelectionChange_Calendar_Handler');
                if (selection.mode === 'row') {
                    this.actn_set_SelectedMultiResources(selection.selection); // Save in State
                }

            }, // eo function resourceSelectionChange_Calendar_Handler()




            /******************************************************************* 'Listeners Emit - Created/Updated Events'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Created Single Duty '
            * onCreated_Single_Duty()
            *
            * Desc: Successful Call => emits 'createdduty' Event.
            * Desc: Add Event in Scheduler (via EventStore).
            * Note: Using Response of call:'actn_create_SingleDuty'.
            *
            * @param {Object} response (Response from Call)
            */
            onCreated_Single_Duty: function(response) {

                const eventColors = Vue.prototype.$getEventColors_Calendar(); // 'Calendar'
                let me = this,
                    scheduler = this.$refs.scheduler1.instance,
                    utcDepartureTime = null,
                    utcArrivalTime = null,
                    utcDepartureTimeSleep = null,
                    utcArrivalTimeSleep = null,
                    utcDepartureTimeActivation = null,
                    t = null,
                    note = '',
                    nameEvent = '',
                    tooltiptData = '',
                    style = null;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onCreated_Single_Duty');
                // >>> Run through Response ---------------
                if (response.length) {
                    response.forEach(mybreak => {
                        const getColors = eventColors.find(colors => colors.duty === mybreak.type);

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';
                        style = null;
                        utcDepartureTimeActivation = null;

                        // >>> Notes & More ---------------
                        tooltiptData = Vue.prototype.$buildEventNote(mybreak);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Times ----------------------
                        if (mybreak.type !== 'SICKNESS' && mybreak.type !== 'DAYOFF' && mybreak.type !== 'FREEDAY' && mybreak.type !== 'VACATION' && mybreak.type !== 'UNABLEFLIGHT' && mybreak.type !== 'AVAILABLE') {
                            utcDepartureTime = me.$buildUTCTime(mybreak.from);
                            utcArrivalTime = me.$buildUTCTime(mybreak.to);
                        }

                        if (mybreak.type === 'SICKNESS' || mybreak.type === 'DAYOFF' || mybreak.type === 'FREEDAY' || mybreak.type === 'VACATION' || mybreak.type === 'UNABLEFLIGHT' || mybreak.type === 'AVAILABLE') {
                            utcDepartureTime = moment.utc(mybreak.from, moment.ISO_8601).toDate();
                            utcArrivalTime = moment.utc(mybreak.to, moment.ISO_8601).toDate();

                            utcDepartureTime.setHours(0);
                            utcDepartureTime.setMinutes(0);
                            utcArrivalTime.setHours(23);
                            utcArrivalTime.setMinutes(59);
                        }


                        // >>> Specials -------------------
                        if (mybreak.type === 'DAYOFF') {
                            style = mybreak.activated === true ? 'border-color: #27ca37; color: #27ca37;' : null;
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'FREEDAY') {
                            style = mybreak.activated === true ? 'border-color: #27ca37; color: #27ca37;' : null;
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'RES') {
                            utcDepartureTimeSleep = me.$buildUTCTime(mybreak.sleepFrom);
                            utcArrivalTimeSleep = me.$buildUTCTime(mybreak.sleepTo);
                        }

                        if (mybreak.type === 'STANDBY') {
                            if (mybreak.activationDate !== null) {
                                utcDepartureTimeActivation = me.$buildUTCTime(mybreak.activationDate);
                                style = 'background: repeating-linear-gradient(45deg,#b28b84,#b28b84 10px,#d8cdcb 10px,#d8cdcb 20px); color: #fff;';
                            };
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'AVAILABLE') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'OFFICE') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'VACATION') {
                            style = mybreak.requestStatus === 'REQUESTED' || mybreak.requestStatus === 'MAINREQUEST' || mybreak.requestStatus === 'SECONDARYREQUEST' || mybreak.requestStatus === 'REPLACEMENTREQUEST' ? 'background: repeating-linear-gradient(45deg, #ececec,#ececec 10px,#ccc 10px,#ccc 20px);' : null;
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'RES') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'SICKNESS') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }


                        // >>> Push -----------------------
                        t = {
                            originalId : mybreak.id, // Note: #67
                            resourceId: mybreak.idResource,
                            startDate: utcDepartureTime,
                            endDate: utcArrivalTime,
                            name: getColors.breakName.toUpperCase(),
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: style,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: mybreak.requested,
                            activated: mybreak.activated,
                            remainingDayOff: mybreak.remainingDayOff,
                            // >>> ------------------ AVAILABLE, STANDBY
                            idApt: mybreak.idApt,
                            aptCode: mybreak.aptCode,
                            // >>> ------------------ SICKNESS
                            certificate: mybreak.certificate,
                            fit: mybreak.fit,
                            sickOnTour: mybreak.sickOnTour,
                            sickChild: mybreak.sickChild,
                            // >>> ------------------ RESERVE
                            sleepFrom: utcDepartureTimeSleep,
                            sleepTo: utcArrivalTimeSleep,
                            // >>> ------------------ MEETING
                            dutyComment: mybreak.dutyComment,
                            // >>> ------------------ STANDBY
                            activationDate: utcDepartureTimeActivation,
                            // >>> ------------------ VACATION #611
                            requestStatus: mybreak.requestStatus,
                        };
                        scheduler.eventStore.add(t);
                    });
                }


                // >>> Close Editor Modal -----------------
                switch (response[0].type) {
                    case "DAYOFF":
                        this.showEditorDayoff = false;
                        break;
                    case "AVAILABLE":
                        this.showEditorAvailable = false;
                        break;
                    case "VACATION":
                        this.showEditorVacation = false;
                        break;
                    case "UNABLEFLIGHT":
                        this.showEditorUnableFlight = false;
                        break;
                    case "FREEDAY":
                        this.showEditorFreeday = false;
                        break;
                    case "SICKNESS":
                        this.showEditorSickness = false;
                        break;
                    case "RES":
                        this.showEditorReserve = false;
                        break;
                    case "OFFICE":
                        this.showEditorOffice = false;
                        break;
                    case "MEETING":
                        this.showEditorMeeting = false;
                        break;
                    case "STANDBY":
                        this.showEditorStandby = false;
                        break;
                    default:
                }


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onCreated_Single_Duty()


            /******************************************************************* 'Created Multiple Duties'
            * onCreated_Multiple_Duties()
            *
            * Desc: Successful Call => emits 'createdmultipleduties' Event.
            * Desc: Add Event(s) in Scheduler (via EventStore).
            * Note: Using Response of Call:'actn_create_Multiple_Duty'
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onCreated_Multiple_Duties: function(response) {

                const eventColors = Vue.prototype.$getEventColors_Calendar(); // 'Calendar'
                let me = this,
                    t = null,
                    note = '',
                    style = null,
                    nameEvent = '',
                    tooltiptData = '',
                    utcDepartureTime = null,
                    utcArrivalTime = null,
                    utcDepartureTimeActivation = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onCreated_Multiple_Duties');
                // >>> Run through Response ---------------
                if (response.response.length) {
                    response.response.forEach(duty => {
                        const getColors = eventColors.find(colors => colors.duty === response.type.toUpperCase());

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';
                        style = null;
                        utcDepartureTimeActivation = null;


                        // >>> Notes & More ------------------------------------
                        duty.type = response.type.toUpperCase();
                        tooltiptData = me.$buildEventNote(duty);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;


                        // >>> Times -----------------------------------------------
                        if (duty.type !== 'SICKNESS' && duty.type !== 'DAYOFF' && duty.type !== 'FREEDAY' && duty.type !== 'VACATION' && duty.type !== 'UNABLEFLIGHT' && duty.type !== 'AVAILABLE') {
                            utcDepartureTime = me.$buildUTCTime(duty.from);
                            utcArrivalTime = me.$buildUTCTime(duty.to);
                        }

                        if (duty.type === 'SICKNESS' || duty.type === 'DAYOFF' || duty.type === 'FREEDAY' || duty.type === 'VACATION' || duty.type === 'UNABLEFLIGHT' || duty.type === 'AVAILABLE') {
                            utcDepartureTime = moment.utc(duty.from, moment.ISO_8601).toDate();
                            utcArrivalTime = moment.utc(duty.to, moment.ISO_8601).toDate();

                            utcDepartureTime.setHours(0);
                            utcDepartureTime.setMinutes(0);
                            utcArrivalTime.setHours(23);
                            utcArrivalTime.setMinutes(59);
                        }


                        // >>> Specials ----------------------------------------
                        if (duty.type === 'STANDBY') {
                            if (duty.activationDate !== null) {
                                utcDepartureTimeActivation = me.$buildUTCTime(duty.activationDate);
                                style = 'background: repeating-linear-gradient(45deg,#b28b84,#b28b84 10px,#d8cdcb 10px,#d8cdcb 20px); color: #fff;';
                            };
                            if (duty.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }
                        if (duty.type === 'OFFICE') {
                            if (duty.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }
                        if (duty.type === 'DAYOFF') {
                            if (duty.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }
                        if (duty.type === 'MEETING') {
                            if (duty.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }
                        if (duty.type === 'SICKNESS') {
                            if (duty.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        // >>> Push --------------------------------------------
                        t = {
                            originalId : duty.id,  // Note: #67
                            resourceId: duty.idResource,
                            startDate: utcDepartureTime, // me.$buildUTCTime(duty.from),
                            endDate: utcArrivalTime, // me.$buildUTCTime(duty.to),
                            name: response.type.toUpperCase(),
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            fromOriginal: duty.from,
                            toOriginal: duty.to,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: style,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: duty.requested,
                            activated: duty.activated,
                            remainingDayOff: duty.remainingDayOff,
                            // >>> ------------------
                            idApt: duty.idApt, // originally: AVAILABLE & more
                            aptCode: duty.aptCode,
                            // >>> ------------------
                            certificate: duty.certificate, // originally: SICKNESS
                            fit: duty.fit,
                            sickOnTour: duty.sickOnTour,
                            sickChild: duty.sickChild,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: duty.dutyComment,
                            // >>> ------------------ STANDBY
                            activationDate: utcDepartureTimeActivation,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: null,
                        };
                        scheduler.eventStore.add(t);
                    });
                }

                // >>> Close Editor Modal -----------------
                this.showEditorMeeting = false;
                this.showEditorStandby = false;
                this.showEditorSickness = false;
                this.showEditorUnableFlight = false;
                this.showEditorOffice = false;
                this.showEditorDayoff = false;

                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onCreated_Multiple_Duties()


            /******************************************************************* 'Updated Multiple Duties'
            * onUpdated_Multiple_Duties()
            *
            * Desc: Successful Call => emits 'updatedmultipleduties' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of Call:actn_update_Multiple_Hotels
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onUpdated_Multiple_Duties: function(response){

                let me = this,
                    rec = null,
                    style = null,
                    tooltipData = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onUpdated_Multiple_Duties');
                this.actn_set_SelectedMultiEvents([]); // send empty Array

                // >>> Run through Response ---------------
                if (response.response.length) {
                    response.response.forEach(duty => {
                        duty.type = response.type.toUpperCase(); // set type
                        rec = scheduler.eventStore.findByField('originalId', duty.id);

                        if (duty.type === 'DAYOFF' || duty.type === 'UNABLEFLIGHT' || duty.type === 'SICKNESS') { // special case: make 23:59
                            rec[0].data.setStartEndDate(me.$buildUTCTime(duty.from, true, false), me.$buildUTCTime(duty.to, false, true));
                        } else {
                            rec[0].data.setStartEndDate(me.$buildUTCTime(duty.from), me.$buildUTCTime(duty.to));
                        }

                        rec[0].data.set({ fromOriginal: duty.from });
                        rec[0].data.set({ toOriginal: duty.to });

                        rec[0].data.set({ idApt: duty.idApt });
                        rec[0].data.set({ aptCode: duty.aptCode });
                        rec[0].data.set({ dutyComment: duty.dutyComment });
                        rec[0].data.set({ requested: duty.requested });
                        rec[0].data.set({ remainingDayOff: duty.remainingDayOff });

                        rec[0].data.set({ certificate: duty.certificate });
                        rec[0].data.set({ fit: duty.fit });
                        rec[0].data.set({ sickOnTour: duty.sickOnTour });
                        rec[0].data.set({ sickChild: duty.sickChild });

                        tooltipData = me.$buildEventNote(duty); // Catch after 'requested was set!: Important
                        rec[0].data.set({ nameEvent: tooltipData.nameEvent });
                        rec[0].data.set({ note: tooltipData.note });

                        rec[0].data.set({ activated: duty.activated }); // #552

                        // >>> Style ----------------------------------------
                        if (duty.activationDate !== null) {
                            style = 'background: repeating-linear-gradient(45deg,#b28b84,#b28b84 10px,#d8cdcb 10px,#d8cdcb 20px); color: #fff;';
                        }
                        if (duty.activated === true) { // #552
                            style = 'color: white; background: repeating-linear-gradient(45deg, #ffe81c,#ffe81c 10px,#c0af1a 10px,#c0af1a 20px);';
                        }


                        if (duty.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }

                        rec[0].data.set({ style: style });
                        // <<< Style ----------------------------------------
                    });
                }

                // >>> Close Editor Modal -----------------
                this.showEditorMeeting = false;
                this.showEditorStandby = false;
                this.showEditorSickness = false;
                this.showEditorUnableFlight = false;
                this.showEditorOffice = false;
                this.showEditorDayoff = false;

                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onUpdated_Multiple_Duties()




            /******************************************************************* 'Created Multiple Hotels'
            * onCreated_Multiple_Hotels()
            *
            * Desc: Successful Call => emits 'createdmultiplehotels' Event.
            * Desc: Add Event(s) in Scheduler (via EventStore).
            * Note: Using Response of Call:'actn_create_Multiple_Hotels'.
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onCreated_Multiple_Hotels: function(response) {

                const eventColors = Vue.prototype.$getEventColors_Calendar(); // 'Calendar'
                let me = this,
                    t = null,
                    note = '',
                    nameEvent = '',
                    tooltiptData = '',
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onCreated_Multiple_Hotels');
                if (response.length) {
                    response.forEach(hotel => {
                        const getColors = eventColors.find(colors => colors.duty === 'HOTEL');

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';

                        // >>> Notes & More ------------------------------------
                        hotel.type = 'HOTEL';
                        tooltiptData = me.$buildEventNote(hotel);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Push --------------------------------------------
                        t = {
                            originalId : hotel.id,  // Note: #67
                            resourceId: hotel.idResource,
                            startDate: me.$buildUTCTime(hotel.checkinDate),
                            endDate: me.$buildUTCTime(hotel.checkoutDate),
                            name: 'HOTEL',
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: hotel,
                            // >>> ------------------ PRO
                            proObject: null,
                        };
                        scheduler.eventStore.add(t);
                    });
                }

                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onCreated_Multiple_Hotels()


            /******************************************************************* 'Updated Multiple Hotels'
            * onUpdate_Multiple_Hotels()
            *
            * Desc: Successful Call => emits 'updatedmultiplehotels' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of Call:actn_update_Multiple_Hotels
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_Multiple_Hotels: function(response){

                let me = this,
                    rec = null,
                    tooltipData = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onUpdate_Multiple_Hotels');
                this.actn_set_SelectedMultiEvents([]); // send empty Array

                if (response.length) {
                    response.forEach(hotel => {
                        hotel.type = 'HOTEL'; // set type
                        rec = scheduler.eventStore.findByField('originalId', hotel.id);

                        rec[0].data.setStartEndDate(me.$buildUTCTime(hotel.checkinDate), me.$buildUTCTime(hotel.checkoutDate));
                        rec[0].data.set({ hotelObject: hotel });

                        // rec[0].data.set({ hotelId: hotel.idHotel });
                        // rec[0].data.set({ hotelAddress: hotel.address });
                        // rec[0].data.set({ hotelCityName: hotel.cityName });
                        // rec[0].data.set({ hotelCountryName: hotel.countryName });
                        // rec[0].data.set({ hotelName: hotel.name });

                        tooltipData = me.$buildEventNote(hotel); // Catch after 'requested was set!: Important
                        rec[0].data.set({ nameEvent: tooltipData.nameEvent });
                        rec[0].data.set({ note: tooltipData.note });
                    });
                }

                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onUpdate_Multiple_Hotels()


            /******************************************************************* 'Created Multiple Proceedings'
            * onCreated_Multiple_Proceedings()
            *
            * Desc: Successful Call => emits 'createdmultipleproceedings' Event.
            * Desc: Add Event(s) in Scheduler (via EventStore).
            * Note: Using Response of Call:'actn_create_Multiple_Proceedings'.
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onCreated_Multiple_Proceedings: function(response) {

                const eventColors = Vue.prototype.$getEventColors_Calendar(); // 'Calendar'
                let me = this,
                    scheduler = this.$refs.scheduler1.instance,
                    t = null,
                    note = '',
                    nameEvent = '',
                    tooltiptData = '';


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onCreated_Multiple_Proceedings');
                if (response.length) {
                    response.forEach(proceeding => {
                        const getColors = eventColors.find(colors => colors.duty === 'PROCEEDING');

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';

                        // >>> Notes & More ------------------------------------
                        proceeding.typeOfProceeding = proceeding.type; // special: cause 'type' exits already in pro
                        proceeding.type = 'PRO';
                        tooltiptData = me.$buildEventNote(proceeding);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Push --------------------------------------------
                        t = {
                            originalId : proceeding.id,  // Note: #67
                            resourceId: proceeding.idResource,
                            startDate: me.$buildUTCTime(proceeding.proceedingStart),
                            endDate: me.$buildUTCTime(proceeding.proceedingEnd),
                            name: 'PROCEEDING',
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: proceeding.status === 'PENDING' ? 'border: 1px solid red !important;' : null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: proceeding, // new: simply adding entire object
                        };
                        scheduler.eventStore.add(t);
                    });
                }

                this.showEditorProceeding = false;
                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onCreated_Multiple_Proceedings()


            /******************************************************************* 'Updated Multiple Proceedings'
            * onUpdate_Multiple_Proceedings()
            *
            * Desc: Successful Call => emits 'updatedmultipleproceedings' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of Call:'actn_update_Multiple_Proceedings'.
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_Multiple_Proceedings: function(response){

                let me = this,
                    rec = null,
                    tooltipData = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onUpdate_Multiple_Proceedings');
                this.actn_set_SelectedMultiEvents([]); // send empty Array

                if (response.length) {
                    response.forEach(proceeding => {
                        proceeding.typeOfProceeding = proceeding.type; // special: cause 'type' exits already in pro
                        proceeding.type = 'PRO';
                        rec = scheduler.eventStore.findByField('originalId', proceeding.id);

                        rec[0].data.setStartEndDate(me.$buildUTCTime(proceeding.proceedingStart), me.$buildUTCTime(proceeding.proceedingEnd));
                        rec[0].data.set({ proObject: proceeding });



                        tooltipData = me.$buildEventNote(proceeding); // Catch after 'requested was set!: Important
                        rec[0].data.set({ nameEvent: tooltipData.nameEvent });
                        rec[0].data.set({ note: tooltipData.note });
                    });
                }

                this.showEditorProceeding = false;
                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onUpdate_Multiple_Proceedings()


            /******************************************************************* 'Created Multiple Trainings'
            * onCreated_Multiple_Trainings()
            *
            * Desc: Successful Call => emits 'createdmultipletrainings' Event.
            * Desc: Add Event(s) in Scheduler (via EventStore).
            * Note: Using Response of Call:'actn_create_Multiple_Trainings'.
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onCreated_Multiple_Trainings: function(response) {

                const eventColors = Vue.prototype.$getEventColors_Calendar(); // 'Calendar'
                let me = this,
                    scheduler = this.$refs.scheduler1.instance,
                    t = null,
                    note = '',
                    nameEvent = '',
                    tooltipData = '';


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onCreated_Multiple_Trainings');
                if (response.length) {
                    response.forEach(training => {
                        const getColors = eventColors.find(colors => colors.duty === 'TRAINING');

                        note = ''; // reset
                        nameEvent = '';
                        tooltipData = '';

                        // >>> Notes & More ------------------------------------
                        training.type = 'TRAINING';
                        tooltipData = me.$buildEventNote(training);
                        note += tooltipData.note;
                        nameEvent += tooltipData.nameEvent;

                        // >>> Push --------------------------------------------
                        t = {
                            originalId : training.id,  // Note: #67
                            resourceId: training.idResource,
                            startDate: me.$buildUTCTime(training.nextCheckStartDate),
                            endDate: me.$buildUTCTime(training.nextCheckEndDate),
                            name: 'TRAINING',
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: training.activated === true ? 'border: 1px solid red !important;' : null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: null,
                            // >>> ------------------ TRAINING
                            trainingObject: training,

                        };
                        scheduler.eventStore.add(t);
                    });
                }


                this.showEditorTraining = false;
                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onCreated_Multiple_Trainings()


            /******************************************************************* 'Updated Multiple Trainings'
            * onUpdate_Multiple_Trainings()
            *
            * Desc: Successful Call => emits 'updatedmultipletrainings' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of Call:'actn_update_Multiple_Trainings'.
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_Multiple_Trainings: function(response){

                let me = this,
                    rec = null,
                    tooltipData = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onUpdate_Multiple_Trainings');
                this.actn_set_SelectedMultiEvents([]); // send empty Array

                if (response.length) {
                    response.forEach(training => {
                        training.type = 'TRAINING';
                        rec = scheduler.eventStore.findByField('originalId', training.id);

                        rec[0].data.setStartEndDate(me.$buildUTCTime(training.nextCheckStartDate), me.$buildUTCTime(training.nextCheckEndDate));
                        rec[0].data.set({ trainingObject: training });
                        rec[0].data.set({ style: training.activated === true ? 'border: 1px solid red !important;' : null });


                        tooltipData = me.$buildEventNote(training); // Catch after 'requested was set!: Important
                        rec[0].data.set({ nameEvent: tooltipData.nameEvent });
                        rec[0].data.set({ note: tooltipData.note });
                    });
                }


                this.showEditorTraining = false;
                this.onScheduler_DeselectAll(); // #401


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onUpdate_Multiple_Trainings()




            /******************************************************************* 'Listeners - Closing Editors'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClose_Editors()
            *
            * Desc:
            * Note:
            *
            */
            onClose_Editors: function() {

                let me = this;
                const engine = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClose_Editors');
                if (engine) {
                    engine.refresh();
                }

            }, // eo function onClose_Editors()


            /*******************************************************************
            * onScheduler_DeselectAll()
            *
            * Desc:
            * Note:
            *
            */
            onScheduler_DeselectAll: function() {

                var me = this,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onScheduler_DeselectAll');
                scheduler.deselectAll(false); // deselect all ressources
                scheduler.clearEventSelection(); // deselect all events


                this.actn_set_SelectedMultiEvents([]); // Save/Reset in State
                this.actn_set_SelectedMultiResources([]); // Save/Reset in State

            }, // eo function onScheduler_DeselectAll()


            /*******************************************************************
            * onScheduler_DeselectAllFlights()
            *
            * Desc:
            * Note:
            *
            */
            onScheduler_DeselectAllFlights: function() {

                var me = this,
                    scheduler = this.$refs.scheduler2.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onScheduler_DeselectAllFlights');
                scheduler.deselectAll(false); // deselect all ressources
                scheduler.clearEventSelection(); // deselect all events

            }, // eo function onScheduler_DeselectAllFlights()


            /*******************************************************************
            * onUpdate_Multiple_FlightComments()
            *
            * Desc:
            * Note:
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_Multiple_FlightComments : function(response) {

                var me = this,
                    style = null,
                    tooltipData = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onUpdate_Multiple_FlightComments');
                scheduler.eventStore.forEach(rec => {
                    if ((rec.originalId === response.id) && (rec.name === 'FLIGHT')) {

                        rec.set({ dutyComment: response.dutyComment });

                        response.type = 'FLIGHT';
                        tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                        rec.set({ nameEvent: tooltipData.nameEvent });
                        rec.set({ note: tooltipData.note });

                        if (response.dutyComment !== null) {
                            if (rec.style !== null) {
                                style = rec.style  + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                        rec.set({ style: style });
                    }
                });


            }, // eo function onUpdate_Multiple_FlightComments()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_areThereTrtainingsFlights()
            *
            * Desc:
            * Note:
            *
            */
            get_areThereTrtainingsFlights: function(payload) {

                let me = this,
                    recs = null,
                    isThisATrainingsFlight = false,
                    schedulerCalendar = me.$refs.scheduler1.instance;// 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> get_areThereTrtainingsFlights');
                payload.forEach((idFlight, index) => {
                    // flight = state.cc_Events.find(flight => flight.originalId === idFlight); // leider falsch, da cc_event nicht mehr aktuell ist
                    recs = schedulerCalendar.eventStore.findByField('originalId', idFlight);
                    if (recs.length > 0) {
                        // recs.forEach(rec => {
                        //     console.log(rec.data.name)
                        //     console.log(rec.data.crew)
                        // });
                        if (Vue.prototype.$checkSingleOccurrence(recs[0].data.crew, 'I') || Vue.prototype.$checkSingleOccurrence(recs[0].data.crew, 'T') || Vue.prototype.$checkSingleOccurrence(recs[0].data.crew, 'C')) {
                            isThisATrainingsFlight = true;
                        }
                    }
                });


                return isThisATrainingsFlight;

            }, // eo function get_areThereTrtainingsFlights()




            /*******************************************************************  'Listeners - Scheduler 'Across Both''
            * Listeners: Scheduler 'Across Both'
            *******************************************************************/
            /******************************************************************* 'Partnering Mode'
            * onChange_SchedulerPartneringMode()
            *
            * Desc:
            * Note:
            *
            * @param {Boolean} value ()
            */
            onChange_SchedulerPartneringMode: function(value) {

                const me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onChange_SchedulerPartneringMode');
                if (value === true) {
                    this.$refs.scheduler2.instance.addPartner(this.$refs.scheduler1.instance);
                }

                if (value === false) {
                    this.$refs.scheduler2.instance.removePartner(this.$refs.scheduler1.instance);
                    // setTimeout(() => { // ??
                    //     me.$refs.scheduler1.instance.viewPreset = 1;
                    // }, 250);
                }

            }, // eo function onChange_SchedulerPartneringMode()


            /*******************************************************************
            * onClick_ShowCompleteNames()
            *
            * Desc:
            * Note:
            *
            * @param {Array} crewCodes ()
            */
            onClick_ShowCompleteNames: function(crewCodes) {

                const me = this;
                let result = null;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ShowCompleteNames');
                if (crewCodes.length > 0) {
                    result = me.get_crews_Complete_Names(crewCodes);

                    Vue.prototype.$toasted.global.sdr_app_info2({
                        message: result.toString()
                    });
                }

            }, // eo function onClick_ShowCompleteNames()


            /*******************************************************************
            * onSyncData()
            *
            * Desc:
            * Note: Just for Fun right now!
            *
            */
            onSyncData(event) {

                let { store, action, records } = event;


                // console.log(`${store.id} changed. The action was: ${action}. Changed records: `, records);
                // Your sync data logic comes here

            }, // eo function onSyncData()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
    /* Client events */
    .b-sch-event-wrap {
        border-radius : 4px;
    }
</style>

<style>
    .v-application .headline {
        font-size: 20px !important;
    }
    .theme--light.v-sheet {
        background-color: #f3f4f5;
    }
    /* .theme--light.v-list {
        background: #f3f4f5;
    } */


    /* Flights Tooltip */
    .b-my-class {
        background-color: #66717f !important;
        color: white !important;
    }

    .b-popup-header {
        background-color: #ab2b7a !important;
        color: #fff;
    }


    /* Flights Tooltip */
    .v-application p {
        margin-bottom: 0px;
    }
    .resourceColumn {
        width: 100%;
    }



    .b-grid-cell.b-group-title {
        color: #66717f;
        overflow: visible;
        contain: size layout style;
        font-weight: 600;
        text-transform: capitalize;
    }
    .b-group-row {
        background: #f1eaeb !important;
        color:#fff;
    }

    /* Upper FilterFields */
    .b-numberfield input, .b-numberfield textarea, .b-textfield input, .b-textfield textarea {
        background-color: #f1eaeb;
        color: inherit;
        padding: 0.3em;
        font-weight: 400;
        flex: 1 1 0px;
        border: 0 none;
        margin: 0;
        font-family: inherit;
        font-size: 12px;
        min-width: 1em;
    }
    .b-field-inner {
        background-color: #f2ebec;
    }
    .b-numberfield .b-fieldtrigger:before, .b-textfield .b-fieldtrigger:before {
        font-size: 0.8em;
        transition: all .3s;
        transform: scale(1);
    }
    .b-numberfield .b-fieldtrigger.b-align-end:last-child, .b-textfield .b-fieldtrigger.b-align-end:last-child {
        padding-right: 0.4em;
    }


    /* Scheduler Headers, Font Sizes */
    .b-sch-header-timeaxis-cell {
        font-size: .9em !important;
    }

    .b-grid-header-text > .b-grid-header-text-content {
        font-size: .9em !important;
    }


    /* Scheduler Summyry Footer, Font Sizes */
    .b-grid-footer-summary .b-grid-summary-value {
        font-size: 0.9rem;
    }







    /* Duties */
    .break_FLIGHT {
        background: repeating-linear-gradient(
        45deg,
            #27ca37,
            #27ca37 10px,
            #166d1f 10px,
            #166d1f 20px
        );
    }


    .break_HOTEL {
        /* border-width: 2px !important; */
        color: #3183fe !important;
    }
    .break_TRAINING {
        /* background-image: -webkit-linear-gradient(to bottom, #fea688, #fea688);
        background-image: -moz-linear-gradient(to bottom, #fea688, #fea688);
        background-image: -o-linear-gradient(to bottom, #fea688, #fea688);
        background-image: linear-gradient(to bottom, #fea688, #fea688);
        border-radius: 5px;
        border: 1px solid; */
        color: #feac31 !important;
    }
    .break_OFFICE {
        /* background-image: -webkit-linear-gradient(to bottom, #c492b1, #c492b1);
        background-image: -moz-linear-gradient(to bottom, #c492b1, #c492b1);
        background-image: -o-linear-gradient(to bottom, #c492b1, #c492b1);
        background-image: linear-gradient(to bottom, #c492b1, #c492b1);
        border-radius: 5px;
        border: 1px solid; */
        color: #3183fe !important;

    }
    .break_MEETING{
        /* background-image: -webkit-linear-gradient(to bottom, #dec3d4, #dec3d4);
        background-image: -moz-linear-gradient(to bottom, #dec3d4, #dec3d4);
        background-image: -o-linear-gradient(to bottom, #dec3d4, #dec3d4);
        background-image: linear-gradient(to bottom, #dec3d4, #dec3d4);
        border-radius: 5px;
        border: 1px solid; */
        color: #3183fe !important;

    }



    /* */
    .b-tooltip-content {
        background-color: #f1eaeb;
        color: #4d4d4d;
    }
    .b-sch-event-tooltip {
        font-size: 13px;
        font-family: Roboto;
    }

    .b-sch-style-plain .b-sch-event:not(.b-milestone) {
        border-color: #b9b8b8;
    }



    /* Upper FilterFields */
    .b-numberfield input, .b-numberfield textarea, .b-textfield input, .b-textfield textarea {
        background-color: #f1eaeb;
        color: inherit;
        padding: 0.3em;
        font-weight: 400;
        flex: 1 1 0px;
        border: 0 none;
        margin: 0;
        font-family: inherit;
        font-size: 12px;
        min-width: 1em;
    }
    .b-field-inner {
        background-color: #f2ebec;
    }
    .b-numberfield .b-fieldtrigger:before, .b-textfield .b-fieldtrigger:before {
        font-size: 0.8em;
        transition: all .3s;
        transform: scale(1);
    }
    .b-numberfield .b-fieldtrigger.b-align-end:last-child, .b-textfield .b-fieldtrigger.b-align-end:last-child {
        padding-right: 0.4em;
    }



    /* */
    .b-sch-event.b-milestone label, .b-sch-event-wrap:not(.b-milestone-wrap) .b-sch-event {
        font-size: 10px;
    }




    .b-sch-event-wrap.b-sch-style-line .b-sch-event {
        border-width: 1px 0 0 0;
        padding: 2px 0 0 0;
    }



    /* */
    .b-panel-header .b-header-title {
        font-size: 1.0em;
    }
    .b-popup-header {
        background-color: #EFD9CE;
        color: #4f5964;
    }



    .b-sch-event-wrap.b-sch-style-dashed .b-sch-event {
        border-width: 3px 0 0 0;
    }
    .b-sch-style-minimal:not(.b-milestone) .b-sch-event {
        background-color: transparent;
        border-color: #27ca37;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        padding-left: 2px;
        color:gray;
        font-weight: 500;
        overflow: hidden;
        font-size: 10px;
        align-items: flex-end;
    }
    .b-sch-event-wrap.b-sch-style-dashed .b-sch-event {
        background-color: transparent;
        border-color: #27ca37;
        border-width: 2px 0 0 0;
        border-style: dashed;
        padding: 5px 0 3px 0;
        color: #777;
        font-weight: 500;
        justify-content: center;
        overflow: hidden;
        top: 5px;
        height: auto !important;
    }

    .b-sch-style-hollow.b-sch-event-wrap .b-sch-event:not(.b-milestone) {
        border-width: 1px;
    }



    /* CiCo Milestone */
    .b-sch-style-colored.b-milestone-wrap.b-sch-color-green:not(.b-sch-event-withicon) .b-sch-event:before {
        border: 1px solid #23b632;
    }

    .b-sch-event-wrap.b-milestone-wrap .b-sch-event:not(.b-sch-event-withicon):before, .b-sch-event-wrap.b-milestone-wrap .b-task-baseline:before {
        height: 0.307107em; /* 0.707107em; */
        width: 0.307107em; /* 0.707107em; */
    }



    .b-sch-event {
        padding-left: 0.15em; /* 0.75 */
    }


    /* no column */
    .b-widget {
        font-size: 12px;
    }



    /* birthday, resourcetimerange */
    .b-sch-resourcetimerange {
        display: flex;
        position: absolute;
        background-color: rgba(255,165,0,.2);
        color: #ffffff;
        z-index: 2;
        transition: background-color 0.2s, opacity 0.2s, font-weight 0.2s, font-size 0.2s, border 0.2s;
        font-size: 10px;
        /* justify-content: center; */
        /* align-items: flex-end; */
        text-orientation: upright;
        writing-mode: vertical-rl;
        padding: 3px;
        border-radius: 5px;
    }

    .birthdate {
        xborder: 1px dashed #ff0000 !important;
    }

    .restriction {
        border-top: 1px solid #a4a3a3;
        margin-top: 35px;
        z-index: 50;
        background-color: transparent;
        border-radius: 0px;
        /* background: repeating-linear-gradient(
            45deg,
            #f88c8c,
            #f88c8c 10px,
            #E50E0E 10px,
            #E50E0E 20px
        ); */
    }

    .restrictionerror {
        border-top: 2px solid #ff0000;
        margin-top: 35px;
        z-index: 50;
        background-color: transparent;
        border-radius: 0px;
        /* background: repeating-linear-gradient(
            45deg,
            #f88c8c,
            #f88c8c 10px,
            #E50E0E 10px,
            #E50E0E 20px
        ); */
    }


    .restrictionalternative {
        border-top: 0px solid #38bd38;
        /* margin-top: 35px; */
        background-color: transparent;
        border-radius: 0px;
        background: repeating-linear-gradient(
            45deg,
            #f88c8c,
            #f88c8c 10px,
            #E50E0E 10px,
            #E50E0E 20px
        );
    }



    /* outline when event is active */
    .b-sch-event-wrap:not(.b-milestone-wrap).b-active .b-sch-event {
        outline: 0px solid rgba(3, 3, 3, 0.5); /* No outline border anymore */
    }



    /* */
    .b-menuitem {
        font-family: Roboto
    }



    /* Multiselect Event, All Blues (HOTEL, OFFICE, MEEETING) */
    .b-sch-style-minimal:not(.b-milestone).b-sch-color-blue .b-sch-event:hover, .b-sch-style-minimal:not(.b-milestone).b-sch-color-blue .b-sch-event.b-sch-event-selected {
        background-color: #015be2 !important;
        color: #ffffff !important;
    }

    /* Multiselect Event, All Purple (VACATION) */
    .b-sch-event-wrap.b-sch-style-line.b-sch-color-purple .b-sch-event:hover, .b-sch-event-wrap.b-sch-style-line.b-sch-color-purple .b-sch-event.b-sch-event-selected {
        background-color: #e201cc !important;
        color: #ffffff !important;
    }

    /* Multiselect Event, All Orange (FREEDAY, DAYOFF) */
    .b-sch-event-wrap.b-sch-style-dashed.b-sch-color-orange .b-sch-event:hover, .b-sch-event-wrap.b-sch-style-dashed.b-sch-color-orange .b-sch-event.b-sch-event-selected {
        background-color: #e28801 !important;
        color: #ffffff !important;
    }

    /* Multiselect Event, All Orange (TRAINING) */
    .b-sch-style-minimal:not(.b-milestone).b-sch-color-orange .b-sch-event:hover, .b-sch-style-minimal:not(.b-milestone).b-sch-color-orange .b-sch-event.b-sch-event-selected {
        background-color: #e28801 !important;
        color: #ffffff !important;
    }



    /* FontSize & Margin on Events */
    .b-sch-event:not(.b-milestone) .b-sch-event-content {
        margin: 0 0.5em 0 0.15em;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }

    .b-sch-event.b-milestone label, .b-sch-event .b-sch-event-content, .b-sch-event-wrap:not(.b-milestone-wrap) .b-sch-event {
        font-weight: 500;
        font-size: 11px;
    }


    /* Selected Event Color (note: works for both scheduler) */
    .b-sch-event.b-sch-event-selected {
        background-color: red !important;
    }
    .b-sch-event:not(.b-milestone).b-sch-event-selected .b-sch-event-content, .b-sch-event:not(.b-milestone).b-sch-event-selected .b-sch-event-content * {
        color: #fbfbfb !important;
        font-weight: 600;
    }



    .resourceColumn {
        display: flex;
        flex-direction: row;
        align-items: center

    }

    .resourceColumn .resourceColumn__bubbleTag {
        background-color: #66717f; /* #2d3e52 , a7acb3 */
        height: 30px;
        width: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: 500;
        margin-right: 12px;
        border: 2px solid #ab3b7a;
    }

    .resourceColumn p{
        margin: 0px !important;
    }



    /* Small Labels in Forms */
    .v-label.v-label, .v-alert.v-alert {
        font-size: 14px !important;
    }


    .theme--light.v-label {
        color: rgba(0, 0, 0, 0.5) !important;
    }



    /* #434  kurzer Duty nicht richtig zu erkennen neuer Calendar */
    .b-sch-style-calendar.b-sch-event-wrap .b-sch-event:not(.b-milestone) .b-sch-event-content {
        margin: 0;
        padding: 0.0em;
    }

    .b-sch-event:not(.b-milestone) .b-sch-event-content > :not(i) {
        text-overflow: unset;
        overflow: hidden;
    }



    /* */
	.flight_HasCrew {
		background-color: #809848 !important;
	}

    .flight_HasNoCrew {
		background-color: #96031A !important;
		color: #ffffff !important;
	}

	.flight_HasCrew_And_InvalidGC {
    	background: transparent url('../../../assets/training_red.png') no-repeat 0 0 !important;
		background-position	: right 5px !important;
		background-color: #809848 !important;
    }

	.flight_HasInvalidCrew {
		background-color: #FAA916 !important;
	}

	.flight_HasInvalidCrew_And_InvalidGC {
		background : transparent url('../../../assets/training_red.png') no-repeat 0 0 !important;
		background-position	: right 5px !important;
		background-color: #FAA916 !important;
	}



    /* */
    @media (min-width: 1264px) {
        .container {
            max-width: none !important;
        }
    }
</style>
